import { render, staticRenderFns } from "./vehicleTrip.vue?vue&type=template&id=42b6212e&scoped=true"
import script from "./vehicleTrip.vue?vue&type=script&lang=js"
export * from "./vehicleTrip.vue?vue&type=script&lang=js"
import style0 from "./vehicleTrip.vue?vue&type=style&index=0&id=42b6212e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b6212e",
  null
  
)

export default component.exports